import React from "react";
import MainAuth from "./MainAuth";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Register from "src/components/authentication/Register";

const RegisterView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("auth_register_tab")}</title>
      </Helmet>
      <MainAuth>
        <Register />
      </MainAuth>
    </>
  );
};

export default RegisterView;
